<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->

<form [formGroup]="formGroup">

    <h2 id="EditExpDateDialog" mat-dialog-title appLifecycleTracker
        trackerName="edit-exp-date-dialog">{{ fHeader }}</h2>
    <mat-dialog-content class="content">
        <div>
            <div class="controls-row">
                @if (data.selectedEdition == StripeProductTier.HARDWARE || data.selectedEdition == StripeProductTier.HARDWARE2) {
                    <mat-form-field appearance="outline">
                        <mat-label>{{ 'ADO_EXPIRES' | translate }}</mat-label>
                        <input matInput value="{{ 'NON_EXPIRING' | translate }}" [disabled]="true">
                    </mat-form-field>
                } @else {
                    <mat-form-field [ngStyle]="{'width': '45%'}" appearance="outline">
                        <mat-label>{{ 'ADO_EXPIRES' | translate }}</mat-label>
                        <input id="editDurationExpiration" matInput [matDatepicker]="myExpDatepicker" formControlName="expirationDate"
                               [min]="this.data.minDate" [max]="this.data.maxDate" (click)="myExpDatepicker.open()">
                        <mat-datepicker-toggle matSuffix [for]="myExpDatepicker"></mat-datepicker-toggle>
                        <mat-datepicker #myExpDatepicker></mat-datepicker>
                    </mat-form-field>
                }

                <mat-form-field [ngStyle]="{'width': '45%', 'margin-left': '1em'}" appearance="outline">
                    <mat-label>{{ 'MAINT_EXPIRES' | translate }}</mat-label>
                    <input matInput [matDatepicker]="myMaintDatepicker" formControlName="maintenance_end"
                           [min]="this.data.minDate" [max]="this.data.maxDate" (click)="myMaintDatepicker.open()">
                    <mat-datepicker-toggle matSuffix [for]="myMaintDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #myMaintDatepicker></mat-datepicker>
                </mat-form-field>
            </div>
        </div>

        <mat-divider class="divider"></mat-divider>

        <div>
            <mat-checkbox class="send-email-checkbox" (change)="onNotifyCheckChanged($event)"
                          color="primary">{{ 'EDIT_LICENSE_NOTIFY_ADMINS' | translate }}&nbsp;
            </mat-checkbox>
            <app-language-selector
                    label=""
                    [disabled]="!notifyAdminsByEmail"
                    [selectedLanguage]="selectedLanguage"
                    (valueChange)="onLanguageChanged($event)">
            </app-language-selector>
        </div>
    </mat-dialog-content>
    <div mat-dialog-actions class="button-wrapper">
        <button id="EditExpDateDialogCancel" mat-raised-button (click)="onCancelClick()"
                type="button">{{ fCancel }}
        </button>
        <button id="EditExpDateDialogSave" mat-raised-button (click)="onSubmit()"
                [disabled]="invalidExpiration || invalidDelay"
                type="button" color="primary">{{ fSave }}
        </button>
    </div>

</form>
